import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from './auth';

// API client para la gestión de client_tabs del administrador del tenant
// (uso del ejecutivo autenticado). El tenantId no se envía en el body/query;
// el backend lo toma del JWT y filtra todo por ahí.

const authHeaders = () => ({
  Authorization: getAccessTokenApi(),
  'Content-Type': 'application/json',
});

export const listAdminClientTabs = async () => {
  const res = await axios.get(`${API_PATH}/tenants/me/client-tabs?userType=administrador`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const listAvailableKeysForAdmin = async () => {
  const res = await axios.get(`${API_PATH}/tenants/me/client-tabs/available-keys`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createAdminClientTab = async (payload) => {
  const res = await axios.post(`${API_PATH}/tenants/me/client-tabs`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};

export const updateAdminClientTab = async (id, updates) => {
  const res = await axios.put(`${API_PATH}/tenants/me/client-tabs/${id}`, updates, {
    headers: authHeaders(),
  });
  return res.data;
};

export const deleteAdminClientTab = async (id) => {
  const res = await axios.delete(`${API_PATH}/tenants/me/client-tabs/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const reorderAdminClientTabs = async (updates) => {
  const res = await axios.patch(
    `${API_PATH}/tenants/me/client-tabs/reorder`,
    { updates },
    { headers: authHeaders() }
  );
  return res.data;
};
